const base64URIToBlob = (dataURI) => {
  if (!dataURI || typeof dataURI !== 'string') {
    return new Blob();
  }
  const splitDataURI = dataURI.split(',');
  if (splitDataURI.length !== 2) {
    return new Blob();
  }

  let byteString;
  try {
    byteString =
      splitDataURI[0].indexOf('base64') >= 0
        ? atob(splitDataURI[1])
        : decodeURI(splitDataURI[1]);
  } catch (e) {
    return new Blob();
  }

  let mimeString = '';
  try {
    const [, mimePart = ''] = splitDataURI[0].split(':');
    const [mime = ''] = mimePart.split(';');
    mimeString = mime;
  } catch (e) {
    mimeString = '';
  }

  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);

  return new Blob([ia], { type: mimeString });
};

export default base64URIToBlob;
